// Pour la culture G => C'est ce que l'on appelle du destructuring la. C'est une facon ES6 d'appeler uniquement ce qu'on a besoin d'appeler.
// Pour cela , créer une clé via un module.exports que l'on pourra exporter via nodejs 
// cf => global.js
import { hasSpeechRecognition } from './global';
import browser from 'browser-detect';

jQuery(document).ready(($) => {
    // var SpeechAPI = window.webkitSpeechRecognition

    const RouteResultatsResearch = route('front.resultats-recherche.'+ Lang.getLocale()).toString();
    const RouteResultatsResearchWithRedirect = route('front.resultats-recherche.'+ Lang.getLocale(), {'is-redirect': true}).toString();
    const CurrentUserCheckingRoute = window.origin + window.location.pathname;
    // const isWaiting = $('.is-waiting');
    // const isWaitingIcon = isWaiting.find('i');
    const CurrentLocale = Lang.getLocale()
    const result = browser(navigator.userAgent);

    // const hasSpeechApi = hasSpeechRecognition()

    //      // BOOSTRAP THE ANNYANG RECOGNITION BY LANG
        //  if( CurrentUserCheckingRoute == RouteResultatsResearch) {
        
             require('../bot.js');
             require('./bot-callbacks.js');
   
        //  }

        //  ManageTabsSearch(hasSpeechApi);
    
    




    
})